import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from "react";
import styles from "./SuggestionPicker.module.css";
/**
 * Sugestões prontas para estado vazio, do Azim CRM (SuggestionPicker).
 * Seleção múltipla por cartão — cada sugestão é um checkbox nativo, operável
 * por teclado e por clique, com descrição auxiliar.
 */
export function SuggestionPicker({ options, selected, onToggle }) {
    const groupId = useId();
    return (_jsx("div", { className: styles.root, role: "group", children: options.map((opt) => {
            const checked = selected.includes(opt.value);
            const inputId = `${groupId}-${opt.value}`;
            return (_jsxs("label", { htmlFor: inputId, className: [styles.option, checked ? styles.optionSelected : ""].filter(Boolean).join(" "), children: [_jsx("input", { id: inputId, type: "checkbox", className: styles.checkbox, checked: checked, onChange: () => onToggle(opt.value) }), _jsx("span", { className: styles.optionLabel, children: opt.label }), _jsx("span", { className: styles.description, children: opt.description })] }, opt.value));
        }) }));
}
//# sourceMappingURL=SuggestionPicker.js.map